import { CellContext, ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { LastModifiedCell } from 'components/Table'
import { COLUMN_SIZE } from 'components/Table/constants'
import { StatusChip } from 'features/ab-tests/components/StatusChip'
import { ActionsCell } from './components/ActionsCell'
import { DurationCell } from './components/DurationCell'
import { AbTestsForTable } from './hooks/useGetAbTests/types'

export const useColumns = (): ColumnDef<AbTestsForTable>[] => {
  const { t } = useTranslation('features/abTests')

  return [
    {
      accessorKey: 'name',
      header: t('list.header.name'),
    },
    {
      accessorKey: 'domainName',
      header: t('list.header.domainName'),
    },
    {
      accessorKey: 'startedAt',
      cell: (props: CellContext<AbTestsForTable, unknown>) => (
        <DurationCell date={props.row.original.startedAt} />
      ),
      header: t('list.header.startedAt'),
    },
    {
      accessorKey: 'endedAt',
      cell: (props: CellContext<AbTestsForTable, unknown>) => (
        <DurationCell date={props.row.original.endedAt} />
      ),
      header: t('list.header.endedAt'),
    },
    {
      accessorKey: 'status',
      cell: (props: CellContext<AbTestsForTable, unknown>) => (
        <StatusChip status={props.row.original.status} />
      ),
      header: t('list.header.status'),
    },
    {
      accessorKey: 'updatedAt',
      cell: (props: CellContext<AbTestsForTable, unknown>) => <LastModifiedCell {...props} />,
      header: t('list.header.lastModified'),
    },
    {
      cell: (props: CellContext<AbTestsForTable, unknown>) => <ActionsCell {...props} />,
      header: t('list.header.actions'),
      id: 'actions',
      meta: {
        centered: true,
        nonClickable: true,
      },
      size: COLUMN_SIZE.SM,
    },
  ]
}
